export default {
  welcome: () =>
    'Welcome to Acorns. We’re in the process of making Acorns more accessible. If you need any help navigating our app, please contact our support team at acorns.com/support',
}
